module.exports = __webpack_public_path__ + "700ae5c327a2e71be8b6154f6b5358f6.pdf";